/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Col, Flex, Form, Row } from "antd";
import { InputField } from "../../../../../atoms/FormFields";
import { TimePickerField } from "../../../../../atoms/FormFields/TimePickerField";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { AddressComponent, Place } from "../../../../Company/ducks/types";
import { AutoCompleteField } from "../../../../../atoms/FormFields/AutoComplete";
import { changeStartOrEndPoint } from "../../../ducks/services";
import dayjs from "dayjs";
import { useAppDispatch } from "../../../../../config/hooks";
import { getScheduleByDay } from "../../../ducks/actions";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../atoms/Toasts/ErrorMessage";

const CustomAddress = ({
  scheduleId,
  onCloseHandler,
  isStartPoint,
  selectedDate,
  setLoading,
}: {
  scheduleId?: any;
  onCloseHandler: () => void;
  isStartPoint?: boolean;
  selectedDate: any;
  setLoading: any;
}) => {
  // const [showMapImage, setShowMapImage] = useState(false);
  const [googleAddress, setGoogleAddress] = useState<Place | null>(null);
  const dispatch = useAppDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (val: any) => {
    setLoading(true);
    const timeStr = val?.allocatedTime?.format("HH:mm");
    let decimalHours = 0;
    if (timeStr) {
      const [h, m] = timeStr.split(":").map(Number);
      decimalHours = h * 60 + m;
    }

    let city = "";
    let state = "";
    let zip = "";
    googleAddress?.address_components?.forEach(
      (component: AddressComponent) => {
        if (component.types.includes("locality")) {
          city = component.long_name;
        }
        if (component.types.includes("administrative_area_level_1")) {
          state = component.short_name;
        }
        if (component.types.includes("postal_code")) {
          zip = component.long_name;
        }
      }
    );

    let payload = {};
    if (isStartPoint) {
      payload = {
        starting_point_duration: decimalHours,
        schedule_id: scheduleId ?? undefined,
        starting_point: "CUSTOM",
        is_changing_start_point: isStartPoint,

        starting_custom_location_name: val?.locationName,
        starting_custom_street_address: googleAddress?.formatted_address || "",
        starting_custom_city: city,
        starting_custom_state: state,
        starting_custom_zip: zip,
        starting_custom_latitude: googleAddress?.geometry?.location?.lat() || 0,
        starting_custom_longitude:
          googleAddress?.geometry?.location?.lng() || 0,
      };
    } else {
      payload = {
        finish_point_duration: decimalHours,
        schedule_id: scheduleId ?? undefined,
        finish_point: "CUSTOM",
        is_changing_start_point: false,

        finishing_custom_location_name: val?.locationName,
        finishing_custom_street_address: googleAddress?.formatted_address || "",
        finishing_custom_city: city,
        finishing_custom_state: state,
        finishing_custom_zip: zip,
        finishing_custom_latitude:
          googleAddress?.geometry?.location?.lat() || 0,
        finishing_custom_longitude:
          googleAddress?.geometry?.location?.lng() || 0,
      };
    }
    console.log(val, payload);

    changeStartOrEndPoint(payload)
      .then(() => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        SuccessMessage(`${isStartPoint ? "Start" : "Finish"} point updated`);
        onCloseHandler();
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  return (
    <Form
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
      onKeyDown={(e) => {
        if (e.key === "Enter") e.preventDefault();
      }}
    >
      <Card className="custom-address-card">
        <Flex
          justify="space-between"
          align="center"
          style={{ marginBottom: "12px" }}
        >
          <h5>Custom Address</h5>
          {/* <Button
            className={
              showMapImage ? "btn-sm primary-btn" : "btn-sm outlined-btn"
            }
            type={showMapImage ? "primary" : "default"}
            onClick={() => setShowMapImage(!showMapImage)}
          >
            <MapIcon style={{ color: showMapImage ? "white" : "#151718" }} />{" "}
            Set on map
          </Button> */}
        </Flex>
        <Row gutter={16}>
          {/* {showMapImage && (
            <Col span={24}>
              <Image
                src="/images/schedule/map-placeholder.png"
                alt="Map Placeholder"
                preview={false}
                style={{ marginBottom: 6 }}
              />
            </Col>
          )} */}
          <Col span={15}>
            <InputField
              fieldName="locationName"
              label="Location name"
              control={control}
              defaultValue=""
              iProps={{
                placeholder: "Enter location name",
              }}
              isRequired
              rules={{
                required: "Location name is required.",
              }}
              validate={errors.locationName && "error"}
              validMessage={
                typeof errors.locationName?.message === "string"
                  ? errors.locationName.message
                  : undefined
              }
            />
          </Col>
          <Col span={9}>
            <TimePickerField
              fieldName="allocatedTime"
              label="Allocated time"
              control={control}
              isRequired
              rules={{
                required: "Allocated time is required.",
              }}
              validate={errors.allocatedTime && "error"}
              validMessage={
                typeof errors.allocatedTime?.message === "string"
                  ? errors.allocatedTime.message
                  : undefined
              }
              tooltipTitle="Allocated Time"
            />
          </Col>

          <Col span={24}>
            <AutoCompleteField
              fieldName="streetAddress"
              label="Street address"
              control={control}
              defaultValue=""
              iProps={{
                placeholder: "Search street address",
              }}
              onPlaceChange={(place: Place) => setGoogleAddress(place)}
            />
          </Col>
          {/* <Col span={24}>
            <Row gutter={8}>
              <Col span={10} className="mb-0">
                <InputField
                  fieldName="city"
                  label="City"
                  control={control}
                  defaultValue=""
                  iProps={{
                    placeholder: "City",
                  }}
                />
              </Col>
              <Col span={7} className="mb-0">
                <SelectField
                  fieldName="state"
                  label="State"
                  control={control}
                  selectOption={[]}
                  iProps={{
                    placeholder: "State",
                  }}
                />
              </Col>
              <Col span={7} className="mb-0">
                <InputField
                  fieldName="zip"
                  label="ZIP"
                  control={control}
                  defaultValue=""
                  iProps={{
                    placeholder: "ZIP",
                  }}
                />
              </Col>
            </Row>
          </Col> */}
        </Row>
      </Card>
      <div className="modal_footer">
        <Button
          htmlType="button"
          className="outlined-btn"
          type="default"
          size="large"
          onClick={onCloseHandler}
        >
          Cancel
        </Button>

        <Button
          htmlType="submit"
          className="mint-btn"
          type="primary"
          size="large"
        >
          Save changes
        </Button>
      </div>
    </Form>
  );
};

export default CustomAddress;
